export const ASIDE_WIDTH = 140;
export const ASIDE_MIN_WIDTH = 74;
export const HEADER_HEIGHT = 62;
export const ASIDE_ITEM_HEIGHT = 56;
export const SPECIALIST = {
  ENCOUNTER: 'ENCOUNTER',
  DENTAL: 'DENTAL',
};
